// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Dashboard/FirstReception.css */

.first-reception-container {
    width: 100%;
    height: 100%;
    min-width: 0;
    min-height: 0;
    padding: 8px;
    background: #f6f8fb;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.reception-hero {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex: 0 0 auto;
    padding: 10px 12px;
    border: none;
    border-radius: 8px;
    background: linear-gradient(135deg, #ffffff 0%, #eef6ff 100%);
    box-shadow: 0 12px 28px rgba(31, 46, 64, 0.08);
}

.reception-kicker {
    margin: 0 0 4px;
    color: #EF6F53;
    font-size: 0.74rem;
    font-weight: 700;
    letter-spacing: 0;
    text-transform: uppercase;
}

.reception-hero h1 {
    margin: 0;
    color: #24384f;
    font-size: clamp(1.35rem, 2.2vw, 2.15rem);
    font-weight: 950;
    letter-spacing: 0;
    text-transform: uppercase;
}

.reception-hero-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    flex: 0 1 520px;
    min-width: 0;
}

.reception-hero-actions input {
    width: 100%;
    height: 34px;
    border: 1px solid rgba(54, 76, 99, 0.18);
    border-radius: 8px;
    padding: 0 12px;
    color: #24384f;
    background: #ffffff;
    font-size: 0.9rem;
    outline: none;
    box-shadow: inset 0 1px 2px rgba(31, 46, 64, 0.04);
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.reception-hero-actions input:focus {
    border-color: #EF6F53;
    box-shadow: 0 0 0 3px rgba(239, 111, 83, 0.14);
}

.reception-hero-actions button {
    border: 1px solid transparent;
    border-radius: 8px;
    background: #EF6F53;
    color: #ffffff;
    cursor: pointer;
    font-size: 0.84rem;
    font-weight: 600;
    white-space: nowrap;
    transition: background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}

.reception-hero-actions button {
    height: 34px;
    padding: 0 10px;
    box-shadow: 0 10px 20px rgba(239, 111, 83, 0.18);
}

.reception-hero-actions button:hover {
    background: #d95b43;
    transform: translateY(-1px);
}

.reception-hero-actions .reception-refresh-button {
    background: #16324f;
    color: #ffffff;
    border-color: rgba(22, 50, 79, 0.18);
    box-shadow: 0 10px 20px rgba(22, 50, 79, 0.16);
}

.reception-hero-actions .reception-refresh-button:hover {
    background: #dff1ff;
    color: #1d5fa7;
}

.reception-hero-actions .reception-refresh-button:disabled {
    cursor: not-allowed;
    opacity: 0.65;
    transform: none;
}

.reception-stats-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    flex: 0 0 auto;
    gap: 8px;
    margin-top: 8px;
}

.reception-stats-grid--four {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

.reception-stat-card {
    position: relative;
    text-align: left;
    overflow: hidden;
    min-height: 38px;
    padding: 7px 10px 7px 14px;
    border: 1px solid rgba(54, 76, 99, 0.1);
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 10px 24px rgba(31, 46, 64, 0.06);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
}

.reception-stat-button {
    width: 100%;
    border: 1px solid rgba(54, 76, 99, 0.1);
    cursor: pointer;
    font-family: inherit;
    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.reception-stat-button:hover,
.reception-stat-button:focus-visible {
    border-color: rgba(103, 80, 164, 0.32);
    box-shadow: 0 16px 32px rgba(31, 46, 64, 0.11);
    transform: translateY(-2px);
    outline: none;
}

.reception-stat-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
}

.reception-stat-card.accent-blue::before {
    background: #236b9a;
}

.reception-stat-card.accent-green::before {
    background: #2f9e75;
}

.reception-stat-card.accent-orange::before {
    background: #EF6F53;
}

.reception-stat-card.accent-purple::before {
    background: #6750a4;
}

.reception-stat-card span {
    display: block;
    color: #66788f;
    font-size: 0.76rem;
    font-weight: 650;
}

.reception-stat-card strong {
    display: block;
    margin-top: 0;
    color: #24384f;
    font-size: 1.2rem;
    line-height: 1;
}

.reception-summary-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    flex: 0 0 auto;
    gap: 8px;
    margin-top: 8px;
}

.reception-summary-grid--two {
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.reception-info-panel {
    position: relative;
    overflow: hidden;
    padding: 7px 10px;
    border: 1px solid rgba(29, 95, 167, 0.18);
    border-radius: 8px;
    background:
        radial-gradient(circle at top right, rgba(82, 199, 184, 0.18), transparent 38%),
        linear-gradient(135deg, #ffffff 0%, #eef7ff 100%);
    box-shadow: 0 10px 22px rgba(31, 46, 64, 0.07);
}

.reception-info-panel::before {
    content: '';
    position: absolute;
    inset: 0 auto 0 0;
    width: 4px;
    background: linear-gradient(180deg, #1d5fa7, #52c7b8);
}

.reception-info-panel h2 {
    position: relative;
    margin: 0 0 5px;
    color: #16324f;
    font-size: 0.9rem;
    font-weight: 750;
}

.summary-row {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 4px 0;
    border-top: 1px solid rgba(29, 95, 167, 0.12);
}

.summary-row span {
    color: #5d7281;
    font-size: 0.76rem;
    font-weight: 800;
    text-transform: uppercase;
}

.summary-row strong {
    color: #16324f;
    font-size: 0.84rem;
    font-weight: 850;
    text-align: right;
}

.teams-sectioonn {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    margin-top: 8px;
    overflow: hidden;
}

.companies-heading {
    flex: 0 0 auto;
    margin: 0 0 6px;
    color: #24384f;
    font-size: 1.12rem;
    font-weight: 800;
    letter-spacing: 0;
}

.teaaamms-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 310px));
    grid-auto-rows: minmax(0, 1fr);
    gap: 16px;
    width: 100%;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
    justify-content: start;
}

.teeam-carrd {
    display: flex;
    flex-direction: column;
    min-width: 0;
    min-height: 0;
    border: 1px solid rgba(25, 118, 210, 0.12);
    border-bottom: 3px solid #1976d2;
    border-radius: 8px;
    background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
    box-shadow: 0 10px 24px rgba(54, 76, 99, 0.11);
    cursor: pointer;
    overflow: hidden;
    position: relative;
    transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;
}

.teeam-carrd::before {
    content: '';
    position: absolute;
    inset: 0 auto auto 0;
    width: 100%;
    height: 4px;
    background: linear-gradient(90deg, #EF6F53, #1976d2);
    z-index: 1;
}

.first-reception-container--companies .teeam-carrd {
    height: 100%;
}

.first-reception-container:not(.first-reception-container--companies) .teeam-carrd {
    height: 100%;
}

.first-reception-container--companies .reception-company-associates {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
}

.first-reception-container:not(.first-reception-container--companies) .reception-company-associates {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
}

.teeam-carrd:hover,
.teeam-carrd:focus-visible {
    transform: translateY(-4px);
    border-color: rgba(239, 111, 83, 0.28);
    box-shadow: 0 18px 34px rgba(54, 76, 99, 0.16);
    outline: none;
}

.team-card-header {
    flex: 0 0 auto;
    padding: 14px 14px 8px;
    background:
        radial-gradient(circle at top right, rgba(255, 255, 255, 0.24), transparent 34%),
        linear-gradient(135deg, #15314f 0%, #1d5fa7 58%, #0f7c73 100%);
    position: relative;
    overflow: hidden;
    border-bottom: 1px solid rgba(29, 95, 167, 0.2);
}

.team-card-header::before {
    content: '';
    position: absolute;
    inset: 0 0 auto 0;
    width: 100%;
    height: 3px;
    background: linear-gradient(90deg, #EF6F53, #f7c948, #52c7b8);
}

.team-card-header::after {
    content: '';
    position: absolute;
    inset: auto 8px 7px 8px;
    height: 1px;
    background: rgba(255, 255, 255, 0.18);
}

.team-card-header.company-summary-card {
    flex: 0 0 auto;
}

.team-card-title-row {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
    min-width: 0;
}

.team-card-title-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    min-width: 0;
    flex: 1 1 auto;
}

.teeamm-name {
    margin: 0;
    color: #ffffff;
    font-size: 1.08rem;
    line-height: 1.25;
    font-weight: 900;
    letter-spacing: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-shadow: none;
    max-width: 100%;
}

.team-card-extension {
    display: block;
    flex: 0 0 auto;
    margin: 0;
    color: #ffffff;
    font-size: 0.78rem;
    font-weight: 850;
    white-space: nowrap;
}

.team-extension-call-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    margin-left: auto;
    width: 34px;
    height: 34px;
    border: 1px solid rgba(255, 255, 255, 0.55);
    border-radius: 999px;
    background: linear-gradient(135deg, #00f5d4, #00bbf9 48%, #fee440);
    color: #102030;
    cursor: pointer;
    box-shadow: 0 10px 22px rgba(0, 187, 249, 0.28);
    transition: background 160ms ease, color 160ms ease, border-color 160ms ease, box-shadow 160ms ease;
}

.team-extension-call-button:hover:not(:disabled) {
    background: linear-gradient(135deg, #ff006e, #fb5607);
    border-color: rgba(255, 255, 255, 0.78);
    color: #ffffff;
    box-shadow: 0 10px 24px rgba(255, 0, 110, 0.34);
}

.team-extension-call-button:disabled {
    cursor: not-allowed;
    background: rgba(255, 255, 255, 0.24);
    color: rgba(255, 255, 255, 0.68);
    box-shadow: none;
}

.reception-company-associates {
    display: flex;
    flex-direction: column;
    gap: 7px;
    padding: 8px;
    cursor: default;
}

.reception-associate-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 7px 8px;
    border: 1px solid rgba(54, 76, 99, 0.08);
    border-radius: 7px;
    background: #f8fafc;
    box-shadow: none;
}

.reception-associate-row--available {
    border-color: rgba(24, 134, 82, 0.36);
    background: #dff6e8;
    box-shadow: inset 3px 0 0 #23a566;
}

.reception-associate-row--not-available {
    border-color: rgba(206, 151, 38, 0.4);
    background: #fff4c7;
    box-shadow: inset 3px 0 0 #d99a19;
}

.reception-associate-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    min-width: 0;
    flex: 1 1;
}

.reception-associate-name {
    color: #24384f;
    font-size: 0.9rem;
    font-weight: 900;
    overflow-wrap: anywhere;
    min-width: 0;
}

.reception-associate-extension {
    color: #66788f;
    font-size: 0.76rem;
    font-weight: 800;
    flex: 0 0 auto;
}

.reception-call-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 30px;
    height: 30px;
    border: 0;
    border-radius: 999px;
    background: linear-gradient(135deg, #7c3aed, #06b6d4);
    color: #ffffff;
    cursor: pointer;
    box-shadow: 0 8px 16px rgba(124, 58, 237, 0.22);
    transition: background 160ms ease, color 160ms ease, box-shadow 160ms ease;
}

.reception-call-button:hover:not(:disabled) {
    background: linear-gradient(135deg, #10b981, #f59e0b);
    color: #ffffff;
    box-shadow: 0 10px 20px rgba(16, 185, 129, 0.28);
}

.reception-call-button:disabled {
    cursor: not-allowed;
    background: #a6adb7;
    color: #f4f6f8;
    opacity: 1;
    box-shadow: none;
}

.reception-call-button i {
    font-size: 0.82rem;
}

.reception-no-associates {
    padding: 9px;
    border: 1px dashed rgba(54, 76, 99, 0.18);
    border-radius: 7px;
    background: #ffffff;
    color: #66788f;
    font-size: 0.84rem;
    font-weight: 700;
    text-align: center;
}

.membbers-grid {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 1 1 auto;
    min-height: 0;
    padding: 8px;
    overflow-y: auto;
}

.membeer-card {
    display: grid;
    grid-template-columns: minmax(110px, 1fr) minmax(150px, 1.4fr) minmax(95px, 0.9fr);
    align-items: center;
    gap: 8px;
    padding: 8px 9px;
    border: 1px solid rgba(54, 76, 99, 0.1);
    border-radius: 6px;
    background: #f8fafc;
}

.member-name,
.member-email,
.member-phone {
    min-width: 0;
    color: #4f6075;
    font-size: 0.82rem;
    line-height: 1.25;
    overflow-wrap: anywhere;
}

.member-name {
    color: #24384f;
    font-weight: 750;
}

.member-phone a {
    color: #236b9a;
    text-decoration: none;
}

.member-phone a:hover {
    color: #EF6F53;
}

.no-members,
.empty-companies,
.loading,
.error {
    padding: 24px;
    color: #66788f;
    text-align: center;
    border: 1px dashed rgba(54, 76, 99, 0.18);
    border-radius: 8px;
    background: #ffffff;
    font-size: 0.95rem;
}

.error {
    color: #c0392b;
}

@media (max-width: 900px) {
    .reception-hero,
    .reception-summary-grid {
        grid-template-columns: 1fr;
    }

    .reception-hero {
        align-items: stretch;
        flex-direction: column;
    }

    .reception-hero-actions {
        flex-basis: auto;
    }

    .reception-stats-grid--four,
    .reception-summary-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 720px) {
    .first-reception-container {
        padding: 8px;
    }

    .reception-stats-grid,
    .reception-stats-grid--four,
    .reception-summary-grid {
        grid-template-columns: 1fr;
    }

    .reception-hero-actions {
        align-items: stretch;
        flex-direction: column;
    }

    .teaaamms-grid {
        grid-template-columns: 1fr;
    }

    .membeer-card {
        grid-template-columns: 1fr;
        gap: 4px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Dashboard/FirstReception.css"],"names":[],"mappings":"AAAA,uDAAuD;;AAEvD;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,6DAA6D;IAC7D,8CAA8C;AAClD;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,cAAc;IACd,yCAAyC;IACzC,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,kDAAkD;IAClD,wDAAwD;AAC5D;;AAEA;IACI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iFAAiF;AACrF;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gDAAgD;AACpD;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,oCAAoC;IACpC,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,cAAc;IACd,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;IAC1B,uCAAuC;IACvC,kBAAkB;IAClB,mBAAmB;IACnB,8CAA8C;IAC9C,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,WAAW;IACX,uCAAuC;IACvC,eAAe;IACf,oBAAoB;IACpB,6EAA6E;AACjF;;AAEA;;IAEI,sCAAsC;IACtC,8CAA8C;IAC9C,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,cAAc;IACd,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,yCAAyC;IACzC,kBAAkB;IAClB;;yDAEqD;IACrD,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,qDAAqD;AACzD;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8DAA8D;IAC9D,8BAA8B;IAC9B,SAAS;IACT,WAAW;IACX,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,0CAA0C;IAC1C,gCAAgC;IAChC,kBAAkB;IAClB,6DAA6D;IAC7D,8CAA8C;IAC9C,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gFAAgF;AACpF;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;IACX,WAAW;IACX,oDAAoD;IACpD,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,gBAAgB;AACpB;;AAEA;;IAEI,2BAA2B;IAC3B,sCAAsC;IACtC,8CAA8C;IAC9C,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB;;sEAEkE;IAClE,kBAAkB;IAClB,gBAAgB;IAChB,+CAA+C;AACnD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,WAAW;IACX,6DAA6D;AACjE;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,qCAAqC;AACzC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,oBAAoB;IACpB,kEAAkE;IAClE,cAAc;IACd,eAAe;IACf,+CAA+C;IAC/C,mGAAmG;AACvG;;AAEA;IACI,qDAAqD;IACrD,uCAAuC;IACvC,cAAc;IACd,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,gBAAgB;IAChB,wCAAwC;IACxC,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,SAAO;AACX;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,SAAS;IACT,oBAAoB;IACpB,qDAAqD;IACrD,cAAc;IACd,eAAe;IACf,+CAA+C;IAC/C,0EAA0E;AAC9E;;AAEA;IACI,qDAAqD;IACrD,cAAc;IACd,gDAAgD;AACpD;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,yCAAyC;IACzC,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,cAAc;IACd,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kFAAkF;IAClF,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,uCAAuC;IACvC,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;;IAGI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;;IAII,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;;QAEI,0BAA0B;IAC9B;;IAEA;QACI,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,gDAAgD;IACpD;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;;;QAGI,0BAA0B;IAC9B;;IAEA;QACI,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;QAC1B,QAAQ;IACZ;AACJ","sourcesContent":["/* src/components/routes/Dashboard/FirstReception.css */\n\n.first-reception-container {\n    width: 100%;\n    height: 100%;\n    min-width: 0;\n    min-height: 0;\n    padding: 8px;\n    background: #f6f8fb;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.reception-hero {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    flex: 0 0 auto;\n    padding: 10px 12px;\n    border: none;\n    border-radius: 8px;\n    background: linear-gradient(135deg, #ffffff 0%, #eef6ff 100%);\n    box-shadow: 0 12px 28px rgba(31, 46, 64, 0.08);\n}\n\n.reception-kicker {\n    margin: 0 0 4px;\n    color: #EF6F53;\n    font-size: 0.74rem;\n    font-weight: 700;\n    letter-spacing: 0;\n    text-transform: uppercase;\n}\n\n.reception-hero h1 {\n    margin: 0;\n    color: #24384f;\n    font-size: clamp(1.35rem, 2.2vw, 2.15rem);\n    font-weight: 950;\n    letter-spacing: 0;\n    text-transform: uppercase;\n}\n\n.reception-hero-actions {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 10px;\n    flex: 0 1 520px;\n    min-width: 0;\n}\n\n.reception-hero-actions input {\n    width: 100%;\n    height: 34px;\n    border: 1px solid rgba(54, 76, 99, 0.18);\n    border-radius: 8px;\n    padding: 0 12px;\n    color: #24384f;\n    background: #ffffff;\n    font-size: 0.9rem;\n    outline: none;\n    box-shadow: inset 0 1px 2px rgba(31, 46, 64, 0.04);\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.reception-hero-actions input:focus {\n    border-color: #EF6F53;\n    box-shadow: 0 0 0 3px rgba(239, 111, 83, 0.14);\n}\n\n.reception-hero-actions button {\n    border: 1px solid transparent;\n    border-radius: 8px;\n    background: #EF6F53;\n    color: #ffffff;\n    cursor: pointer;\n    font-size: 0.84rem;\n    font-weight: 600;\n    white-space: nowrap;\n    transition: background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.reception-hero-actions button {\n    height: 34px;\n    padding: 0 10px;\n    box-shadow: 0 10px 20px rgba(239, 111, 83, 0.18);\n}\n\n.reception-hero-actions button:hover {\n    background: #d95b43;\n    transform: translateY(-1px);\n}\n\n.reception-hero-actions .reception-refresh-button {\n    background: #16324f;\n    color: #ffffff;\n    border-color: rgba(22, 50, 79, 0.18);\n    box-shadow: 0 10px 20px rgba(22, 50, 79, 0.16);\n}\n\n.reception-hero-actions .reception-refresh-button:hover {\n    background: #dff1ff;\n    color: #1d5fa7;\n}\n\n.reception-hero-actions .reception-refresh-button:disabled {\n    cursor: not-allowed;\n    opacity: 0.65;\n    transform: none;\n}\n\n.reception-stats-grid {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    flex: 0 0 auto;\n    gap: 8px;\n    margin-top: 8px;\n}\n\n.reception-stats-grid--four {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.reception-stat-card {\n    position: relative;\n    text-align: left;\n    overflow: hidden;\n    min-height: 38px;\n    padding: 7px 10px 7px 14px;\n    border: 1px solid rgba(54, 76, 99, 0.1);\n    border-radius: 8px;\n    background: #ffffff;\n    box-shadow: 0 10px 24px rgba(31, 46, 64, 0.06);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n}\n\n.reception-stat-button {\n    width: 100%;\n    border: 1px solid rgba(54, 76, 99, 0.1);\n    cursor: pointer;\n    font-family: inherit;\n    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n}\n\n.reception-stat-button:hover,\n.reception-stat-button:focus-visible {\n    border-color: rgba(103, 80, 164, 0.32);\n    box-shadow: 0 16px 32px rgba(31, 46, 64, 0.11);\n    transform: translateY(-2px);\n    outline: none;\n}\n\n.reception-stat-card::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 4px;\n    height: 100%;\n}\n\n.reception-stat-card.accent-blue::before {\n    background: #236b9a;\n}\n\n.reception-stat-card.accent-green::before {\n    background: #2f9e75;\n}\n\n.reception-stat-card.accent-orange::before {\n    background: #EF6F53;\n}\n\n.reception-stat-card.accent-purple::before {\n    background: #6750a4;\n}\n\n.reception-stat-card span {\n    display: block;\n    color: #66788f;\n    font-size: 0.76rem;\n    font-weight: 650;\n}\n\n.reception-stat-card strong {\n    display: block;\n    margin-top: 0;\n    color: #24384f;\n    font-size: 1.2rem;\n    line-height: 1;\n}\n\n.reception-summary-grid {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    flex: 0 0 auto;\n    gap: 8px;\n    margin-top: 8px;\n}\n\n.reception-summary-grid--two {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.reception-info-panel {\n    position: relative;\n    overflow: hidden;\n    padding: 7px 10px;\n    border: 1px solid rgba(29, 95, 167, 0.18);\n    border-radius: 8px;\n    background:\n        radial-gradient(circle at top right, rgba(82, 199, 184, 0.18), transparent 38%),\n        linear-gradient(135deg, #ffffff 0%, #eef7ff 100%);\n    box-shadow: 0 10px 22px rgba(31, 46, 64, 0.07);\n}\n\n.reception-info-panel::before {\n    content: '';\n    position: absolute;\n    inset: 0 auto 0 0;\n    width: 4px;\n    background: linear-gradient(180deg, #1d5fa7, #52c7b8);\n}\n\n.reception-info-panel h2 {\n    position: relative;\n    margin: 0 0 5px;\n    color: #16324f;\n    font-size: 0.9rem;\n    font-weight: 750;\n}\n\n.summary-row {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    padding: 4px 0;\n    border-top: 1px solid rgba(29, 95, 167, 0.12);\n}\n\n.summary-row span {\n    color: #5d7281;\n    font-size: 0.76rem;\n    font-weight: 800;\n    text-transform: uppercase;\n}\n\n.summary-row strong {\n    color: #16324f;\n    font-size: 0.84rem;\n    font-weight: 850;\n    text-align: right;\n}\n\n.teams-sectioonn {\n    flex: 1 1 auto;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    margin-top: 8px;\n    overflow: hidden;\n}\n\n.companies-heading {\n    flex: 0 0 auto;\n    margin: 0 0 6px;\n    color: #24384f;\n    font-size: 1.12rem;\n    font-weight: 800;\n    letter-spacing: 0;\n}\n\n.teaaamms-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(280px, 310px));\n    grid-auto-rows: minmax(0, 1fr);\n    gap: 16px;\n    width: 100%;\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow: hidden;\n    justify-content: start;\n}\n\n.teeam-carrd {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    min-height: 0;\n    border: 1px solid rgba(25, 118, 210, 0.12);\n    border-bottom: 3px solid #1976d2;\n    border-radius: 8px;\n    background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);\n    box-shadow: 0 10px 24px rgba(54, 76, 99, 0.11);\n    cursor: pointer;\n    overflow: hidden;\n    position: relative;\n    transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;\n}\n\n.teeam-carrd::before {\n    content: '';\n    position: absolute;\n    inset: 0 auto auto 0;\n    width: 100%;\n    height: 4px;\n    background: linear-gradient(90deg, #EF6F53, #1976d2);\n    z-index: 1;\n}\n\n.first-reception-container--companies .teeam-carrd {\n    height: 100%;\n}\n\n.first-reception-container:not(.first-reception-container--companies) .teeam-carrd {\n    height: 100%;\n}\n\n.first-reception-container--companies .reception-company-associates {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-y: auto;\n}\n\n.first-reception-container:not(.first-reception-container--companies) .reception-company-associates {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-y: auto;\n}\n\n.teeam-carrd:hover,\n.teeam-carrd:focus-visible {\n    transform: translateY(-4px);\n    border-color: rgba(239, 111, 83, 0.28);\n    box-shadow: 0 18px 34px rgba(54, 76, 99, 0.16);\n    outline: none;\n}\n\n.team-card-header {\n    flex: 0 0 auto;\n    padding: 14px 14px 8px;\n    background:\n        radial-gradient(circle at top right, rgba(255, 255, 255, 0.24), transparent 34%),\n        linear-gradient(135deg, #15314f 0%, #1d5fa7 58%, #0f7c73 100%);\n    position: relative;\n    overflow: hidden;\n    border-bottom: 1px solid rgba(29, 95, 167, 0.2);\n}\n\n.team-card-header::before {\n    content: '';\n    position: absolute;\n    inset: 0 0 auto 0;\n    width: 100%;\n    height: 3px;\n    background: linear-gradient(90deg, #EF6F53, #f7c948, #52c7b8);\n}\n\n.team-card-header::after {\n    content: '';\n    position: absolute;\n    inset: auto 8px 7px 8px;\n    height: 1px;\n    background: rgba(255, 255, 255, 0.18);\n}\n\n.team-card-header.company-summary-card {\n    flex: 0 0 auto;\n}\n\n.team-card-title-row {\n    position: relative;\n    z-index: 2;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    width: 100%;\n    min-width: 0;\n}\n\n.team-card-title-text {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n    min-width: 0;\n    flex: 1 1 auto;\n}\n\n.teeamm-name {\n    margin: 0;\n    color: #ffffff;\n    font-size: 1.08rem;\n    line-height: 1.25;\n    font-weight: 900;\n    letter-spacing: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    text-shadow: none;\n    max-width: 100%;\n}\n\n.team-card-extension {\n    display: block;\n    flex: 0 0 auto;\n    margin: 0;\n    color: #ffffff;\n    font-size: 0.78rem;\n    font-weight: 850;\n    white-space: nowrap;\n}\n\n.team-extension-call-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 auto;\n    margin-left: auto;\n    width: 34px;\n    height: 34px;\n    border: 1px solid rgba(255, 255, 255, 0.55);\n    border-radius: 999px;\n    background: linear-gradient(135deg, #00f5d4, #00bbf9 48%, #fee440);\n    color: #102030;\n    cursor: pointer;\n    box-shadow: 0 10px 22px rgba(0, 187, 249, 0.28);\n    transition: background 160ms ease, color 160ms ease, border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.team-extension-call-button:hover:not(:disabled) {\n    background: linear-gradient(135deg, #ff006e, #fb5607);\n    border-color: rgba(255, 255, 255, 0.78);\n    color: #ffffff;\n    box-shadow: 0 10px 24px rgba(255, 0, 110, 0.34);\n}\n\n.team-extension-call-button:disabled {\n    cursor: not-allowed;\n    background: rgba(255, 255, 255, 0.24);\n    color: rgba(255, 255, 255, 0.68);\n    box-shadow: none;\n}\n\n.reception-company-associates {\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n    padding: 8px;\n    cursor: default;\n}\n\n.reception-associate-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    padding: 7px 8px;\n    border: 1px solid rgba(54, 76, 99, 0.08);\n    border-radius: 7px;\n    background: #f8fafc;\n    box-shadow: none;\n}\n\n.reception-associate-row--available {\n    border-color: rgba(24, 134, 82, 0.36);\n    background: #dff6e8;\n    box-shadow: inset 3px 0 0 #23a566;\n}\n\n.reception-associate-row--not-available {\n    border-color: rgba(206, 151, 38, 0.4);\n    background: #fff4c7;\n    box-shadow: inset 3px 0 0 #d99a19;\n}\n\n.reception-associate-info {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 2px;\n    min-width: 0;\n    flex: 1;\n}\n\n.reception-associate-name {\n    color: #24384f;\n    font-size: 0.9rem;\n    font-weight: 900;\n    overflow-wrap: anywhere;\n    min-width: 0;\n}\n\n.reception-associate-extension {\n    color: #66788f;\n    font-size: 0.76rem;\n    font-weight: 800;\n    flex: 0 0 auto;\n}\n\n.reception-call-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 auto;\n    width: 30px;\n    height: 30px;\n    border: 0;\n    border-radius: 999px;\n    background: linear-gradient(135deg, #7c3aed, #06b6d4);\n    color: #ffffff;\n    cursor: pointer;\n    box-shadow: 0 8px 16px rgba(124, 58, 237, 0.22);\n    transition: background 160ms ease, color 160ms ease, box-shadow 160ms ease;\n}\n\n.reception-call-button:hover:not(:disabled) {\n    background: linear-gradient(135deg, #10b981, #f59e0b);\n    color: #ffffff;\n    box-shadow: 0 10px 20px rgba(16, 185, 129, 0.28);\n}\n\n.reception-call-button:disabled {\n    cursor: not-allowed;\n    background: #a6adb7;\n    color: #f4f6f8;\n    opacity: 1;\n    box-shadow: none;\n}\n\n.reception-call-button i {\n    font-size: 0.82rem;\n}\n\n.reception-no-associates {\n    padding: 9px;\n    border: 1px dashed rgba(54, 76, 99, 0.18);\n    border-radius: 7px;\n    background: #ffffff;\n    color: #66788f;\n    font-size: 0.84rem;\n    font-weight: 700;\n    text-align: center;\n}\n\n.membbers-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    flex: 1 1 auto;\n    min-height: 0;\n    padding: 8px;\n    overflow-y: auto;\n}\n\n.membeer-card {\n    display: grid;\n    grid-template-columns: minmax(110px, 1fr) minmax(150px, 1.4fr) minmax(95px, 0.9fr);\n    align-items: center;\n    gap: 8px;\n    padding: 8px 9px;\n    border: 1px solid rgba(54, 76, 99, 0.1);\n    border-radius: 6px;\n    background: #f8fafc;\n}\n\n.member-name,\n.member-email,\n.member-phone {\n    min-width: 0;\n    color: #4f6075;\n    font-size: 0.82rem;\n    line-height: 1.25;\n    overflow-wrap: anywhere;\n}\n\n.member-name {\n    color: #24384f;\n    font-weight: 750;\n}\n\n.member-phone a {\n    color: #236b9a;\n    text-decoration: none;\n}\n\n.member-phone a:hover {\n    color: #EF6F53;\n}\n\n.no-members,\n.empty-companies,\n.loading,\n.error {\n    padding: 24px;\n    color: #66788f;\n    text-align: center;\n    border: 1px dashed rgba(54, 76, 99, 0.18);\n    border-radius: 8px;\n    background: #ffffff;\n    font-size: 0.95rem;\n}\n\n.error {\n    color: #c0392b;\n}\n\n@media (max-width: 900px) {\n    .reception-hero,\n    .reception-summary-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .reception-hero {\n        align-items: stretch;\n        flex-direction: column;\n    }\n\n    .reception-hero-actions {\n        flex-basis: auto;\n    }\n\n    .reception-stats-grid--four,\n    .reception-summary-grid {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n}\n\n@media (max-width: 720px) {\n    .first-reception-container {\n        padding: 8px;\n    }\n\n    .reception-stats-grid,\n    .reception-stats-grid--four,\n    .reception-summary-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .reception-hero-actions {\n        align-items: stretch;\n        flex-direction: column;\n    }\n\n    .teaaamms-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .membeer-card {\n        grid-template-columns: 1fr;\n        gap: 4px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
